import React from "react";
import styled from "@emotion/styled";
import { TooltipProps, Tooltip, tooltipClasses } from "@mui/material";

type Props = {
	tooltipStyle?: {
		fontSize?: string;
		fontWeight?: string;
		padding?: string;
		border?: string;
	};
	tooltipProps: TooltipProps;
};

export const CustomTooltip: React.FC<Props> = ({
	tooltipStyle,
	tooltipProps,
}) => {
	const TooltipElement = styled(({ className, ...props }: TooltipProps) => (
		<Tooltip {...props} classes={{ popper: className }} />
	))(() => ({
		[`& .${tooltipClasses.tooltip}`]: {
			fontSize: tooltipStyle?.fontSize || "",
			fontWeight: tooltipStyle?.fontWeight || "",
			padding: tooltipStyle?.padding || "",
			border: tooltipStyle?.border || "",
		},
	}));

	return (
		<TooltipElement
			title={tooltipProps.title}
			arrow={tooltipProps.arrow || false}
			placement={tooltipProps.placement}
			PopperProps={{
				className: tooltipProps.className,
			}}
		>
			{tooltipProps.children}
		</TooltipElement>
	);
};
